import { render } from "./formView.vue?vue&type=template&id=88d1705c&scoped=true"
import script from "./formView.vue?vue&type=script&lang=js"
export * from "./formView.vue?vue&type=script&lang=js"

import "./formView.vue?vue&type=style&index=0&id=88d1705c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d1705c"]])

export default __exports__